import { render, staticRenderFns } from "./PenilaianEvent.vue?vue&type=template&id=2f858206&"
import script from "./PenilaianEvent.vue?vue&type=script&lang=js&"
export * from "./PenilaianEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports